import routes from '../routes';
import { UserTypes } from 'src/modules/Auth/store/types';
import { RoutePathsFn, IRouteModule, RoutesModules } from '../types';
import TermsOfUse from '../../Auth/TermsOfUse/TermsOfUse';

const moduleRoutes: RoutePathsFn = () => ([
  {
    paths: [routes.TERMSOFUSE],
    component: TermsOfUse,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN, UserTypes.LAWENFORCEMENTAGENT]
  }
]);

export const commonModule = (): IRouteModule => ({
  name: RoutesModules.COMMON,
  routes: moduleRoutes()
});


// WEBPACK FOOTER //
// ./src/modules/Routing/modules/common.ts